module.exports = __webpack_public_path__ + "img/test04.6f334f96.png";